import { combineReducers, configureStore } from '@reduxjs/toolkit'
import navReducer from './navSlice'
import userReducer from './userSlice'
import centerReducer from './center'
import elearningReducer from './elearning.slice'
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',
  storage,
  // KHÔNG persist slice `elearning`. Slice này chứa course/quiz data mà URL
  // ảnh (`courseimageProxy`, ảnh câu hỏi) nhúng chữ ký `sig` HẾT HẠN SAU 30
  // PHÚT. Nếu persist → lần mở sau redux-persist rehydrate URL `sig` CŨ đã
  // hết hạn → <img> gọi BE → 401 → ảnh vỡ (incognito không persist nên luôn
  // tươi → OK; xóa cache KHÔNG xóa localStorage nên vẫn vỡ). Toàn bộ slice
  // được StudentElearningLayout fetch lại mỗi lần mount → bỏ persist là đúng
  // và triệt tiêu hẳn lỗi ảnh-hết-hạn-sig.
  blacklist: ['elearning'],
}

const rootReducer = combineReducers({
  nav: navReducer,
  user: userReducer,
  center: centerReducer,
  elearning: elearningReducer
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk],
})

export const persistor = persistStore(store)
